import LayoutPage from '@features/ui-layout/templates/LayoutPage';
import { usePathname } from 'next/navigation';

export default function AuthLayout({ children }: { children: React.ReactNode }): JSX.Element {
  const pathname = usePathname();

  return (
    <LayoutPage withCard withLogo={pathname !== '/reset-password'}>
      {children}
    </LayoutPage>
  );
}
